/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  GoogleSignupNonce
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Issue a single-use nonce for one Google Identity Services prompt.
 * @summary Google Signup Nonce
 */
export const googleSignupNonce = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<GoogleSignupNonce>(
      {url: `/auth/google-signup/nonce`, method: 'POST', signal
    },
      options);
    }




export const getGoogleSignupNonceMutationKey = () => ['googleSignupNonce'] as const;

export const getGoogleSignupNonceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof googleSignupNonce>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof googleSignupNonce>>, TError,void, TContext> => {

const mutationKey = getGoogleSignupNonceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof googleSignupNonce>>, void> = () => {


          return  googleSignupNonce(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GoogleSignupNonceMutationResult = NonNullable<Awaited<ReturnType<typeof googleSignupNonce>>>

    export type GoogleSignupNonceMutationError = unknown


    /**
 * @summary Google Signup Nonce
 */
export const useGoogleSignupNonce = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof googleSignupNonce>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof googleSignupNonce>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGoogleSignupNonceMutationOptions(options));
    }
